import Query from "./query";

class GetModelPosition extends Query {
    constructor() {
        super("model");
    }

    async executeChildQuery(modelId, options) {
        if (!modelId) {
            throw new Error('No model is selected from script');
        }

        const TrainingTree = await TrainingTreeController._trainingFeature.getActiveTraining();
        modelId = TrainingTree.resources[modelId] ? TrainingTree.resources[modelId].id : modelId;

        const model = getModelObject(modelId);
        const position = model.position;
        return position.toArray();
    }
}

export default GetModelPosition;
